import { useEffect, useState } from "react";
import { useFetchData, usePostApiRequest } from "../../../helpers/api";
import DashboardLayout from "../DashboardLayout";
import LoadingSpinner from "../../../components/loading/LoadingSpinner";
import InlineSpinner from "../../../components/loading/InlineSpinner";
import StoreLinkTable from "./StoreLinkTable";
import Cookies from "js-cookie";
import CustomMultiSelect from "../../../components/CustomMultiSelect";
import useCategoriesCollections from "../../../helpers/useCategoriesCollections";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const clientCode = customerData?.Code;
const theKeyId = customerData?.Id ? customerData.Id : null;

const StoreLink = () => {
  const postApiRequest = usePostApiRequest();
  const { categoryData, collectionData } = useCategoriesCollections();
  const [formData, setFormData] = useState({
    CustomerCode: "",
    CustomerName: "",
    DiamondStockFilter: false,
    Category: "",
    Collections: "",
    Id: 0,
  });

  const [errors, setErrors] = useState({ CustomerCode: "", CustomerName: "", Category: "", Collections: "" });
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const { data: storeLinkData, isLoading, refetch } = useFetchData(
    "customerStorelink",
    "/Customer/GetCustomerStoreLinksByClient",
    { ClientId: theKeyId }
  );

  useEffect(() => {
    refetch();
  }, []);

  const handleChange = (e) => {
    // old code running
    // handleGlobalInputChange(e, setFormData);
    // setErrors({ ...errors, [e.target.name]: "" });

    const { name, type, checked, value } = e.target;

    // Handle checkbox vs other inputs
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const formValidation = () => {
    const { CustomerCode, CustomerName } = formData;
    let hasError = false;
    let newErrors = {
      CustomerCode: "",
      CustomerName: "",
      selectedCategory: "",
      selectedCollection: "",
      GSTNo: "",
    };
    if (!CustomerCode.trim()) {
      newErrors.CustomerCode = "Client Code is required.";
      hasError = true;
    } else if (!/^[a-zA-Z0-9]+$/.test(CustomerCode)) {
      newErrors.CustomerCode =
        "Client Code must contain only letters and digits.";
      hasError = true;
    } else if (CustomerCode.length <= 3 || CustomerCode.length > 10) {
      newErrors.CustomerCode =
        "Client Code must be between 3 and 10 characters.";
      hasError = true;
    } else {
      newErrors.CustomerCode = "";
    }
    if (!CustomerName.trim()) {
      newErrors.CustomerName = "Customer Name is required.";
      hasError = true;
    }
    if (selectedCategory.length === 0) {
      newErrors.selectedCategory = "Please Select Category.";
      hasError = true;
    }
    if (selectedCollection.length === 0) {
      newErrors.selectedCollection = "Please Select Collection.";
      hasError = true;
    }
    if (hasError) {
      setErrors(newErrors);
      return;
    }
    return !hasError;
  };

  const saveStorelinkHandler = async () => {
    if (!formValidation()) return;
    setIsLoadingData(true);

    const payLoad = {
      Id: formData.Id,
      PartnerId: theKeyId,
      PartnerCode: clientCode,
      CustomerName: formData.CustomerName,
      CustomerCode: formData.CustomerCode,
      Category: Array.isArray(selectedCategory) ? selectedCategory.join(',') : "",
      Collections: Array.isArray(selectedCollection) ? selectedCollection.join(',') : "",
      IsDiamondStockFilter: formData.DiamondStockFilter,
      status: 1,
    };

    try {
      await postApiRequest({
        url: "/Customer/SaveCustomerStoreLink",
        method: "POST",
        data: payLoad,
      });
      refetch();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingData(false);
    }
    setFormData({
      CustomerCode: "",
      CustomerName: "",
      Category: "",
      Collections: "",
      GSTNo: "",
    });
    setSelectedCategory([]);
    setSelectedCollection([]);
    setIsEdit(false);
  };

  const codeGenrater = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const totalLength = 10;
    const numCount = Math.floor(Math.random() * 2) + 5;
    const charCount = totalLength - numCount;
    let result = [];
    for (let i = 0; i < numCount; i++) {
      result.push(numbers.charAt(Math.floor(Math.random() * numbers.length)));
    }

    for (let i = 0; i < charCount; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * characters.length))
      );
    }

    result = result.sort(() => 0.5 - Math.random()).join("");
    setFormData({ ...formData, CustomerCode: result });

    if (errors.CustomerCode !== "") {
      setErrors({ ...errors, CustomerCode: "" });
    }
  };

  const mapOptions = (data, valueKey, labelKey) =>
    data?.map((option) => ({
      value: String(option[valueKey]),
      label: option[labelKey],
    }));

  const toggleCollectionOption = (value) => {
    setSelectedCollection((prev) => {

      const normalizedPrev = Array.isArray(prev)
        ? prev.map(String)
        : [String(prev)];
      const newValue = String(value);

      const updatedSelection = normalizedPrev.includes(newValue)
        ? normalizedPrev.filter((item) => item !== newValue)
        : [...normalizedPrev, newValue];

      if (updatedSelection.length > 0 && errors.selectedCollection) {
        setErrors((prevErrors) => ({ ...prevErrors, selectedCollection: "" }));
      }

      return updatedSelection;
    });
  };

  const toggleCategoryOption = (value) => {

    setSelectedCategory((prev) => {
      const normlizedPrev = Array.isArray(prev)
        ? prev.map(String)
        : [String(prev)];
      const newValue = String(value);

      const updatedSelection = normlizedPrev.includes(newValue)
        ? normlizedPrev.filter((item) => item !== newValue)
        : [...normlizedPrev, newValue];

      // Clear error if category at selected time
      if (updatedSelection.length > 0 && errors.selectedCategory) {
        setErrors((prevErrors) => ({ ...prevErrors, selectedCategory: "" }));
      }
      return updatedSelection;
    });

  };

  const editHandler = (item) => {
    const categoryArray = typeof item.Category === 'string'
      ? item.Category.split(',').map(String)
      : item.Category || [];

    const collectionArray = typeof item.Collections === 'string'
      ? item.Collections.split(',').map(String)
      : item.Collections || [];

    setFormData({
      CustomerCode: item.CustomerCode,
      CustomerName: item.CustomerName,
      GSTNo: item.GSTNo,
      Id: item.Id,
    });

    setSelectedCategory(categoryArray);
    setSelectedCollection(collectionArray);
    setIsEdit(true);
  };


  return (
    <DashboardLayout pageClass="store_links_page">
      <div className="storelink_main_con">
        <div className="store-links mb-4">
          <h5>Generate New Links</h5>
        </div>

        {isLoadingData && <LoadingSpinner />}
        {isLoading ? (
          <div className="loading_screen">
            <InlineSpinner />
          </div>
        ) : (
          <>
            <div className="store_link_form">
              {/* Client Code Field */}
              <div>
                <label htmlFor="" className="mb-2 font-medium">
                  Customer Code :
                </label>
                <input
                  type="text"
                  name="CustomerCode"
                  placeholder="Enter Custmer Code"
                  onChange={handleChange}
                  value={formData.CustomerCode || ""}
                  maxLength={20}
                  inputMode="numeric"
                />
                <div>
                  {errors && (
                    <p className="my_store_link_errormsg">
                      {errors.CustomerCode}
                    </p>
                  )}
                </div>
                <button onClick={codeGenrater} className="generate_code">
                  Generate Code
                </button>
              </div>

              {/* Customer Name Field */}
              <div className="customerName_field">
                <label htmlFor="" className="mb-2 font-medium">
                  Customer Name :
                </label>
                <input
                  type="text"
                  name="CustomerName"
                  placeholder="Enter Customer Name"
                  onChange={handleChange}
                  value={formData.CustomerName || ""}
                />
                {errors && (
                  <p className="my_store_link_errormsg">
                    {errors.CustomerName}
                  </p>
                )}
              </div>

              <div className="category_slecter">
                <label htmlFor="" className="mb-2">
                  Category :
                </label>
                <CustomMultiSelect
                  placeholder="Select Category"
                  placeholderKey="Category"
                  customClass="collection_multiselect_filter"
                  options={mapOptions(
                    categoryData?.Data,
                    "GatiCategoryId",
                    "DesgGroupName"
                  )}
                  dropdownValue={selectedCategory}
                  toggleCollectionOption={toggleCategoryOption}
                />
                {errors && (
                  <p className="my_store_link_errormsg">
                    {errors.selectedCategory}
                  </p>
                )}
              </div>
              {/* collection filter */}
              <div className="collection_multiselect_selecter">
                <label htmlFor="" className="mb-2">
                  Collection :
                </label>
                <CustomMultiSelect
                  placeholder="Select Collection"
                  placeholderKey="Collection"
                  customClass="collection_multiselect_filter"
                  options={mapOptions(
                    collectionData?.Data,
                    "GatiCategoryId",
                    "DesgGroupName"
                  )}
                  dropdownValue={selectedCollection}
                  toggleCollectionOption={toggleCollectionOption}
                />
                {errors && (
                  <p className="my_store_link_errormsg">
                    {errors.selectedCollection}
                  </p>
                )}
              </div>
            </div>
            {/* Save Button */}
            <div className="generate_btn">
              <div className="filtercheck">
                <input
                  type="checkbox"
                  name="DiamondStockFilter"
                  checked={formData.DiamondStockFilter}
                  onChange={handleChange}
                /> Filter with diamond
              </div>
              <button
                className="btn btn-success"
                onClick={saveStorelinkHandler}
              >
                {isEdit ? "Update" : "Generate Link"}
              </button>
            </div>

            <StoreLinkTable
              data={storeLinkData?.Data}
              isLoadingData={isLoadingData}
              refetch={refetch}
              onEdit={editHandler}
            />
          </>
        )}
      </div>
    </DashboardLayout>
  );
};

export default StoreLink;
